<template>
    <el-dialog title="黑名单" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form size="small">
        <el-form-item label="是否拉黑">
            <el-radio-group v-model="isBlack">
    <el-radio :label="0">正常</el-radio>
    <el-radio :label="1">黑名单</el-radio>
  </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
    import UserApi from '@/api/user.js';
    export default {
      data() {
        return {
          /*左边长度*/
          formLabelWidth: '120px',
          /*是否显示*/
          loading: false,
          dialogVisible: false,
        
          isBlack:0
        };
      },
      props: ['open_black', 'form'],
      created() {
        this.dialogVisible = this.open_black;
        this.isBlack=this.form.isBlack
      },
      methods: {
      
        /*添加用户*/
        onSubmit() {
          let self = this;
          self.loading = true;
          UserApi.setblack({
            userId: self.form.userId,
            isBlack: self.isBlack
          }, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        },
        /*关闭弹窗*/
        dialogFormVisible(e) {
          if (e) {
            this.$emit('closeDialog', {
              type: 'success',
              open_black: false
            })
          } else {
            this.$emit('closeDialog', {
              type: 'error',
              open_black: false
            })
          }
        }
  
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/user/user/dialog/black.vue